<template>
    <div class="LeftRight">
      <div class="Sidebarnav">
        <ul>
          <p class="pone"></p>
          <li :class="activeKey==ele.productCategoryId?'borderLeft':''" @click="borderTrue(ele.productCategoryId)" style="text-align: center;padding-top: 1px;padding-bottom: 1px;" v-for="(ele,index) in SidebarList" :key="index">{{ele.productCategoryName}}</li>
          <p class="ptwo"></p>
        </ul>
      </div>
      <div class="SidebarComnt" v-for="(ele,index) in ComntRext" :key="index" v-show="activeKey==ele.id">
        <div class="Comleft">
          <div class="SidebarComntImg">
              <van-image :src="ele.pic">
                <template v-slot:error>加载失败</template>
              </van-image>
          </div>
          <div class="comnt" v-for="(ele,index) in ele.children" :key="index">
            <div class="heardName">{{ele.name}}</div>
            <p style="border:0.5px solid #ccc;"></p>
            <div class="comntmarginTop" style="display: flex; justify-content: flex-start; flex-wrap:wrap; align-items:stretch;">
              <dl class="comntDl" v-for="(ele,index) in ele.children" :key="index" @click="goHome(ele)">
                <dt>
                  <van-image :src="ele.pic">
                    <template v-slot:error>加载失败</template>
                  </van-image>
                </dt>
                <dd style="text-algin:center;">{{ele.name}}</dd>
              </dl>
            </div>
          </div>
        </div>
      </div>
    </div>
</template>
<script>
import { Image, Toast } from 'vant'
import { apiAddress, Categorization } from '../../request/api.js'
export default {
  components: {
    [Image.name]: Image,
    [Toast.name]: Toast
  },
  data () {
    return {
      activeKey: 11,
      SidebarList: [],
      ComntRext: []
    }
  },
  created () {
    this.productCategoryOne()
    this.productCategoryTwoThree()
    Toast.loading({
      message: '加载中...',
      forbidClick: true,
      loadingType: 'spinner'
    })
  },
  methods: {
    borderTrue (index) {
      this.activeKey = index
      this.productCategoryTwoThree()
    },
    productCategoryOne () {
      apiAddress().then(res => {
        this.SidebarList = res.data
      }).catch(res => {
        console.log(res)
      })
    },
    productCategoryTwoThree () {
      Toast.loading({
        message: '加载中...',
        forbidClick: true,
        loadingType: 'spinner'
      })
      const params = {
        product_category_id: this.activeKey
      }
      Categorization(params).then(res => {
        console.log(res)
        this.ComntRext = res.data
        Toast.clear()
      }).catch(res => {
        console.log(res)
      })
    },
    goHome (index) {
      console.log(index)
      this.$router.push({ path: '/classification', query: { Roll: index.id, ID: this.activeKey, name: index.name } })
    }
  }
}
</script>
<style lang="less" scoped>
  .LeftRight {
    width: 100%;
    height: 93%;
    overflow: auto;
    display: flex;
    justify-content: space-between;
  }
  .Sidebarnav {
    width: 160px;
    overflow: auto !important;
    border-right: 0.5px solid #ccc;/*no*/
  }
  .borderLeft {
    border-left:1px solid #B4272D; /*no*/
    color: #B4272D;
  }
  .Sidebarnav ul li {
    margin-bottom: 57px;
    height: 30px;
    line-height: 30px;
    font-size: 28px;
  }
  .Sidebarnav ul li:nth-last-child(2){
    margin-bottom: 0px;
  }
  .SidebarComnt {
    width: 588px;
    height: 1665px‬ ;
    overflow: auto !important;
  }
  .pone {
    padding-top: 27px;
  }
  .ptwo {
    padding-bottom: 57px;
  }
  .SidebarComntImg{
    margin-top: 24px;
    width: 534px;
    height: 240px;
    .van-image{
      width: 100%;
      height: 100%;
    }
  }
  .heardName {
    width: 100%;
    height:28px;
    font-size:28px;
    font-weight:bold;
    color:rgba(51,51,51,1);
    line-height:30px;
    margin-bottom: 16px;
  }
  .Comleft {
    margin-left: 24px;
    margin-right: 30px;
  }
  .comnt {
    margin-top: 40px;
    box-sizing:border-box;
  }
  .comntDl {
    width: 120px;
    margin-right: 58px;
    dt{
      width: 100%;
      height: 120px;
      .van-image{
        width: 100%;
        height: 120px;
      }
    }
    dd{
      margin-top: 16px;
      font-size: 24px;
      text-align: center;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      text-align: center;
    }
  }
  .comntmarginTop {
    margin-top: 32px;
    box-sizing:border-box;
  }
  .comntmarginTop dl:nth-child(1){
    margin-left: 17px;
  }
  .comntmarginTop dl:nth-child(3){
    margin-right: 0px;
  }
  .comntmarginTop dl:nth-of-type(n+4){
    margin-top: 71px;
  }
</style>
